import type { AppUpdate } from '@/types';
import { apiClient } from './api';

export const updatesApi = {
  async getActiveUpdate(accessToken?: string): Promise<AppUpdate | null> {
    return apiClient.getActiveUpdate(accessToken);
  },

  async dismissUpdate(id: number, accessToken?: string): Promise<void> {
    return apiClient.dismissUpdate(id, accessToken);
  },
};
